export default __webpack_public_path__ + "static/myval-18b7116d7af4b48816bb57abc8d93b96.jpg";